import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private apiUrl = `${this.configService.baseUrl}`;

  constructor(private http: HttpClient, private configService: ConfigService) { }

  // GET method
  getData<T = any>(endpoint: string, params?: HttpParams): Observable<T> {
   /* if (!params) {
      params = new HttpParams();
    }
    if (optionalBody) {
      // Convert the optionalBody object into HttpParams
      Object.keys(optionalBody).forEach((key) => {
        params = params.append(key, optionalBody[key]);
      });
    }*/
    return this.http.get<T>(`${this.apiUrl}/${endpoint}`, { params });
  }

  // POST method
  postData<T = any>(endpoint: string, body: any, headers?: HttpHeaders): Observable<T> {
    return this.http.post<T>(`${this.apiUrl}/${endpoint}`, body, { headers });
  }

  // PUT method
  updateData<T = any>(endpoint: string, body: any, headers?: HttpHeaders): Observable<T> {
    return this.http.put<T>(`${this.apiUrl}/${endpoint}`, body, { headers });
  }

  // DELETE method
  deleteData<T = any>(endpoint: string, headers?: HttpHeaders): Observable<T> {
    return this.http.delete<T>(`${this.apiUrl}/${endpoint}`, { headers });
  }

  // PATCH method
  patchData(endpoint: string, body: any, headers?: HttpHeaders): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${endpoint}`, body, { headers });
  }

  updateHotelProfileInfo(body: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/hotel/profile/update`,body);
  }

  checkHotelContract(hotelId: any): Observable<any> {
    return this.http.get(`${this.apiUrl}/hotel/contract/find/${hotelId}`);
  }

  getCountriesList(): Observable<any> {
    return this.http.get(`${this.apiUrl}/location/countries`);
  }

  publishHotel(body): Observable<any> {
    return this.http.post(`${this.apiUrl}/hotel/publish`,body);
  }
  unpublishHotel(body): Observable<any> {
    return this.http.post(`${this.apiUrl}/hotel/unpublish`,body);
  }

  publishHotelRoom(body): Observable<any> {
    return this.http.post(`${this.apiUrl}/hotel/room/publish`,body);
  }
  unpublishHotelRoom(body): Observable<any> {
    return this.http.post(`${this.apiUrl}/hotel/room/unpublish`,body);
  }

   updateTerms_Conditions(body): Observable<any> {
    return this.http.post(`${this.apiUrl}/user/tc/update`,body);
  }

  getBankList(country): Observable<any> {
    return this.http.get(`${this.apiUrl}/paystack/banks?country=${country}`);
  }
}
